<!-- eslint-disable max-len -->
<template>
<svg
    width="32" height="32" viewBox="0 0 32 32"
    fill="none" xmlns="http://www.w3.org/2000/svg"
>
    <path
        d="M11.0682 13.335C10.8963 13.3444 10.7252 13.3061 10.5737 13.2243C10.4223 13.1424 10.2964 13.0203 10.21 12.8715C10.1236 12.7226 10.0801 12.5527 10.0843 12.3806C10.0884 12.2085 10.1401 12.0409 10.2335 11.8964L15.2015 4.00169C15.2796 3.86112 15.3926 3.7431 15.5297 3.65907C15.6668 3.57504 15.8233 3.52785 15.984 3.52209C16.1447 3.51632 16.3041 3.55216 16.4469 3.62615C16.5897 3.70013 16.7109 3.80974 16.7988 3.94436L21.7348 11.8684C21.8321 12.0081 21.8894 12.1718 21.9003 12.3417C21.9113 12.5116 21.8755 12.6812 21.797 12.8323C21.7184 12.9834 21.6001 13.11 21.4547 13.1987C21.3093 13.2873 21.1424 13.3344 20.9722 13.335H11.0682Z"
        stroke="currentColor" stroke-width="2.25"
        stroke-linecap="round" stroke-linejoin="round"
    />
    <path
        d="M12 18.666H5.33333C4.59695 18.666 4 19.263 4 19.9993V26.666C4 27.4024 4.59695 27.9993 5.33333 27.9993H12C12.7364 27.9993 13.3333 27.4024 13.3333 26.666V19.9993C13.3333 19.263 12.7364 18.666 12 18.666Z"
        stroke="currentColor" stroke-width="2.25"
        stroke-linecap="round" stroke-linejoin="round"
    />
    <path
        d="M23.3327 27.9993C25.91 27.9993 27.9993 25.91 27.9993 23.3327C27.9993 20.7554 25.91 18.666 23.3327 18.666C20.7554 18.666 18.666 20.7554 18.666 23.3327C18.666 25.91 20.7554 27.9993 23.3327 27.9993Z"
        stroke="currentColor" stroke-width="2.25"
        stroke-linecap="round" stroke-linejoin="round"
    />
</svg>
</template>
